import Axios from "axios";
import {
  antdMessageError,
  antdMessageSuccess,
  errorHandler,
} from "../../helpers/Utils";
import { CREATE_ORDER_STATUS } from "./types";

export const orderInvoiceRemove = (item_id) => async (dispatch) => {
  try {
    const { data } = await Axios.delete(`/api/v1/order_invoices/${item_id}`);
    if (data.success) {
      dispatch({
        type: "ORDER_INVOICE_REMOVE",
        payload: {
          item_id,
          order_id: data.data.order_id,
        },
      });
    }
    console.log(data);
  } catch (err) {
    console.log("Error: ", err);
  }
};

export const orderInvoiceUpdateStatus = (order_id) => async (dispatch) => {
  try {
    console.log("orderInvoiceUpdateStatus");
    const { data: data_invoice } = await Axios.get(
      `/api/v1/order_invoices/order_invoice_update_status?order_id=${order_id}`
    );
    if (data_invoice?.success) {
      dispatch({
        type: CREATE_ORDER_STATUS,
        payload: data_invoice,
      });
    }
  } catch (err) {
    console.log("Error: ", err);
  }
};

export const orderInvoiceGetClientInfo = async (order_id) => {
  try {
    console.log("get_client_info");
    const { data } = await Axios.get(
      `/api/v1/order_invoices/get_client_info?order_id=${order_id}`
    );

    return data;
  } catch (err) {
    antdMessageError();
    errorHandler(err);
    return { success: false };
  }
};

export const orderInvoiceSendForClient = async (params) => {
  try {
    console.log("send_for_client");
    const { data } = await Axios.post(
      "/api/v1/order_invoices/send_for_client",
      params
    );
    antdMessageSuccess();
    return data;
  } catch (err) {
    antdMessageError();
    errorHandler(err);
    return { success: false };
  }
};
